import Vue from 'vue';

import {
  Container,
  Row,
  Col,
  Aside,
  Main,
  Input,
  Button,
  Collapse,
  CollapseItem,
} from 'element-ui';

import Notifications from 'vue-notification';

import '../styles/index.scss';
import 'element-ui/lib/theme-chalk/index.css';

import http from './http';

window.http = http;

Vue.use(Container);
Vue.use(Row);
Vue.use(Col);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Input);
Vue.use(Button);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.use(Notifications);
